export const ADD_PRODUCT = "products/addProduct";
export const REMOVE_PRODUCT = "products/removeProduct";